import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LoadingStateEnum } from '../interfaces/state';

interface LoadingAnalyseProps {
    summary: LoadingStateEnum;
}

export class LoadingAnalyse extends React.Component<LoadingAnalyseProps, {}> {
    constructor(props: LoadingAnalyseProps) {
        super(props);
    }

    render() {
        return (
            <div className="alert alert-info">
                <FontAwesomeIcon icon={faCircleNotch} className="text-info" />&nbsp;
                Loading {this.props.summary.toString()}
            </div>
        );
    }
}
